import React from 'react';
import { useOrion } from '../context/OrionContext';
import Icon from './Icon';

// ─────────────────────────────────────────────────────────────────────────────
// Avisos (toasts).
//
// Substituem os `alert()` nativos da versão 1.x. O motivo não é estética: no
// Windows o alert() rouba o foco da janela e deixa os campos "travados" até a
// pessoa clicar de volta — no meio de um atendimento isso custa segundos e
// atrapalha quem está ao telefone.
// ─────────────────────────────────────────────────────────────────────────────

const ICONE = { ok: 'check', erro: 'alert-circle', info: 'bell' };

export default function Avisos() {
  const { toasts, fecharToast } = useOrion();
  if (!toasts.length) return null;

  return (
    <div className="orion-toasts">
      {toasts.map(t => (
        <div
          key={t.id}
          className={`orion-toast orion-toast-${t.tipo}`}
          onClick={() => { if (t.aoClicar) t.aoClicar(); fecharToast(t.id); }}
          role="status"
        >
          <Icon name={ICONE[t.tipo] || 'bell'} size={15} />
          <div className="ot-corpo">
            {t.titulo && <div className="ot-titulo">{t.titulo}</div>}
            <div className="ot-texto">{t.texto}</div>
          </div>
          <button
            className="ot-fechar"
            onClick={e => { e.stopPropagation(); fecharToast(t.id); }}
            aria-label="Fechar aviso"
          >
            <Icon name="x" size={13} />
          </button>
        </div>
      ))}
    </div>
  );
}
